import { APP_PERMISSION } from '@core/enum/permisson';
import {
  LeadExportFieldEnum,
  LeadSortFieldEnum,
  NoteExportFieldEnum,
  NoteSortFieldEnum,
  PerformanceExportFieldEnum,
  PerformanceSortFieldEnum,
  ProductDetailExportFieldEnum,
  ProductionSortFieldEnum,
  ReportTabEnum
} from '@core/enum/report';
import { KeyedValue } from '@core/models/interfaces/common';

export const ProductDetailsGroupBys: KeyedValue[] = [
  {
    title: 'All',
    value: 'ALL'
  },
  {
    title: 'Owner',
    value: 'OWNER'
  },
  {
    title: 'Agent',
    value: 'AGENT'
  },
  {
    title: 'Company',
    value: 'COMPANY'
  },
  {
    title: 'Product type',
    value: 'PRODUCT_TYPE'
  },
  {
    title: 'Product name',
    value: 'PRODUCT_NAME'
  },
  {
    title: 'Source',
    value: 'SOURCE'
  },
  {
    title: 'Sub source',
    value: 'SUB_SOURCE'
  },
  {
    title: 'Policy status',
    value: 'POLICY_STATUS'
  },
  {
    title: 'Policy status details',
    value: 'POLICY_STATUS_DETAIL'
  },
  {
    title: 'Commission owner',
    value: 'COMMISSION_OWNER'
  },
  {
    title: 'Commission agent',
    value: 'COMMISSION_AGENT'
  },
  {
    title: 'Commission team',
    value: 'COMMISSION_TEAM'
  }
];

export const ReportTabOptions = [
  {
    title: 'production',
    value: ReportTabEnum.PRODUCT,
    order: 1,
    permission: APP_PERMISSION.REPORT_PRODUCTION_DETAILS_RUN
  },
  {
    title: 'performance',
    value: ReportTabEnum.PERFORMANCE,
    order: 2,
    permission: APP_PERMISSION.REPORT_PERFORMANCE_RUN
  },
  {
    title: 'lead',
    value: ReportTabEnum.LEAD,
    order: 3,
    permission: APP_PERMISSION.REPORT_LEAD_RUN
  },
  {
    title: 'note',
    value: ReportTabEnum.NOTE,
    order: 4,
    permission: APP_PERMISSION.RUN_REPORT_NOTE
  }
];

export const LEAD_EXPORT_TO_SORT_FIELD: Record<LeadExportFieldEnum, LeadSortFieldEnum | null> = {
  [LeadExportFieldEnum.USER]: LeadSortFieldEnum.FULLNAME,
  [LeadExportFieldEnum.TOTAL_LEADS_MOVED]: LeadSortFieldEnum.LEAD_MOVED,
  [LeadExportFieldEnum.TOTAL_LEADS_TAKE_CARE]: LeadSortFieldEnum.LEAD_TAKE_CARE,
  [LeadExportFieldEnum.TOTAL_LEADS_CREATED]: LeadSortFieldEnum.LEAD_CREATED,
  [LeadExportFieldEnum.CUSTOMER]: LeadSortFieldEnum.CUSTOMER,
  [LeadExportFieldEnum.PROSPECT]: LeadSortFieldEnum.PROSPECT,
  [LeadExportFieldEnum.HIDDEN]: LeadSortFieldEnum.HIDDEN
};

export const NOTE_EXPORT_TO_SORT_FIELD: Record<NoteExportFieldEnum, NoteSortFieldEnum | null> = {
  [NoteExportFieldEnum.LEAD_ID]: NoteSortFieldEnum.LEAD_ID,
  [NoteExportFieldEnum.LEAD_NAME]: NoteSortFieldEnum.LEAD_NAME,
  [NoteExportFieldEnum.POLICY_NO]: NoteSortFieldEnum.POLICY_NO,
  [NoteExportFieldEnum.OWNER]: NoteSortFieldEnum.OWNER,
  [NoteExportFieldEnum.AGENT]: NoteSortFieldEnum.AGENT,
  [NoteExportFieldEnum.CELL_PHONE]: NoteSortFieldEnum.CELLPHONE,
  [NoteExportFieldEnum.EMAIL]: NoteSortFieldEnum.EMAIL,
  [NoteExportFieldEnum.ADDED_BY]: NoteSortFieldEnum.ADDED_BY,
  [NoteExportFieldEnum.ADDED_DATE]: NoteSortFieldEnum.ADDED_DATE,
  [NoteExportFieldEnum.LAST_NOTE]: NoteSortFieldEnum.APPEND_DATE,
  [NoteExportFieldEnum.TYPE_NOTE]: NoteSortFieldEnum.NOTE_TYPE,
  [NoteExportFieldEnum.NOTE]: NoteSortFieldEnum.NOTE
};

export const PERFORMANCE_EXPORT_TO_SORT_FIELD: Record<PerformanceExportFieldEnum, PerformanceSortFieldEnum | null> = {
  [PerformanceExportFieldEnum.USER]: PerformanceSortFieldEnum.FULLNAME,

  [PerformanceExportFieldEnum.NUMBER_OF_NOTES]: PerformanceSortFieldEnum.NOTE,

  [PerformanceExportFieldEnum.NUMBER_OF_CLICK_CALLS]: PerformanceSortFieldEnum.CLICK_CALL,

  [PerformanceExportFieldEnum.NUMBER_OF_UPDATED_LEADS]: PerformanceSortFieldEnum.UPDATED_LEAD,

  [PerformanceExportFieldEnum.NUMBER_OF_NO_UPDATED_LEADS]: PerformanceSortFieldEnum.NO_UPDATED_LEAD,

  [PerformanceExportFieldEnum.NUMBER_OF_TASKS]: PerformanceSortFieldEnum.TASK,

  [PerformanceExportFieldEnum.NUMBER_OF_APPOINTMENTS]: PerformanceSortFieldEnum.APPOINTMENT,

  [PerformanceExportFieldEnum.TOTAL_LEADS_CREATED]: PerformanceSortFieldEnum.LEAD_CREATED,

  [PerformanceExportFieldEnum.TOTAL_POLICIES_CREATED]: PerformanceSortFieldEnum.POLICY_CREATED,

  [PerformanceExportFieldEnum.HOURS_ONLINE]: PerformanceSortFieldEnum.HOURS_ONLINE
};

export const PRODUCT_DETAIL_EXPORT_TO_SORT_FIELD: Record<ProductDetailExportFieldEnum, ProductionSortFieldEnum | null> =
  {
    [ProductDetailExportFieldEnum.POLICY_NO]: ProductionSortFieldEnum.POLICY_NO,

    [ProductDetailExportFieldEnum.LEAD]: ProductionSortFieldEnum.LEAD,

    [ProductDetailExportFieldEnum.LEAD_ID]: ProductionSortFieldEnum.LEAD_ID,

    [ProductDetailExportFieldEnum.CELLPHONE]: ProductionSortFieldEnum.CELL_PHONE, // không có sort field

    [ProductDetailExportFieldEnum.EMAIL]: ProductionSortFieldEnum.EMAIL, // không có sort field

    [ProductDetailExportFieldEnum.STATE]: ProductionSortFieldEnum.STATE, // không có sort field

    [ProductDetailExportFieldEnum.CREATED_DATE]: ProductionSortFieldEnum.CREATED_DATE,

    [ProductDetailExportFieldEnum.OWNER]: ProductionSortFieldEnum.OWNER,

    [ProductDetailExportFieldEnum.AGENT]: ProductionSortFieldEnum.AGENT,

    [ProductDetailExportFieldEnum.POLICY_STATUS]: ProductionSortFieldEnum.POLICY_STATUS,

    [ProductDetailExportFieldEnum.POLICY_TRACKING]: ProductionSortFieldEnum.POLICY_TRACKING,

    [ProductDetailExportFieldEnum.EFFECTIVE_DATE]: ProductionSortFieldEnum.EFFECTIVE_DATE,

    [ProductDetailExportFieldEnum.PREMIUM_MODE]: ProductionSortFieldEnum.MODE,

    [ProductDetailExportFieldEnum.PREMIUM_PAYMENT]: ProductionSortFieldEnum.PAYMENT,

    [ProductDetailExportFieldEnum.FACE_AMOUNT]: ProductionSortFieldEnum.FACE_AMOUNT,

    [ProductDetailExportFieldEnum.COMPANY]: ProductionSortFieldEnum.COMPANY,

    [ProductDetailExportFieldEnum.PRODUCT_TYPE]: ProductionSortFieldEnum.PRODUCT_TYPE,

    [ProductDetailExportFieldEnum.PRODUCT_NAME]: ProductionSortFieldEnum.PRODUCT_NAME,

    [ProductDetailExportFieldEnum.CONTRIBUTION_YEARS]: ProductionSortFieldEnum.CONTRIBUTION_YEAR,

    [ProductDetailExportFieldEnum.COMMISSION_TEAM]: ProductionSortFieldEnum.COMMISSION_TEAM,

    [ProductDetailExportFieldEnum.COMMISSION_PERCENTAGE]: ProductionSortFieldEnum.COMMISSION_PERCENTAGE,

    [ProductDetailExportFieldEnum.COMMISSION_OWNER]: ProductionSortFieldEnum.COMMISSION_OWNER,

    [ProductDetailExportFieldEnum.COMMISSION_AGENT]: ProductionSortFieldEnum.COMMISSION_AGENT,

    [ProductDetailExportFieldEnum.DESCRIPTION]: ProductionSortFieldEnum.DESCRIPTION, // text, không sortable

    [ProductDetailExportFieldEnum.CREATED_BY]: ProductionSortFieldEnum.CREATED_BY,

    [ProductDetailExportFieldEnum.TARGET_PREMIUM]: ProductionSortFieldEnum.TARGET
  };
